// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/proportional-symbol.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/coxcomb.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/alpha.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/flow.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/pie.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/sparkline.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/waffle.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js!./map-types/bar.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* wrapper DOM */
.em-map-wrapper {
    position: relative;
    display: inline-block;
}

.em-map-wrapper > svg {
    display: block;
}

/* General text settings */
text {
    pointer-events: none;
    font-family: Arial, Helvetica, sans-serif;
}

a text {
    pointer-events: all;
}

/* Main map */
.em-map text,
.em-legend text,
.em-title,
.em-subtitle,
.em-footnote {
    font-family: Arial, Helvetica, sans-serif;
}

.em-map.em-draggable g {
    cursor: grab;
}

.em-map.em-dragging g {
    cursor: grabbing;
    cursor: -webkit-grabbing;
}

/* Coastal margin */
.em-coastal-margin {
    filter: url(#em-coastal-blur);
    stroke-linejoin: round;
    stroke-linecap: round;
    fill: none;
    stroke-width: 1;
    stroke: rgb(0, 52, 107);
}

/* Title and subtitle styling */
.em-title,
.em-inset-title {
    fill: #4c4b4b;
    stroke: none;
}

.em-title {
    font-size: 21px;
    font-weight: bold;
}

.em-subtitle,
.em-inset-subtitle {
    fill: #4c4b4b;
    fill-opacity: 0.9;
    stroke: none;
    stroke-linejoin: round;
    paint-order: stroke;
}

.em-subtitle {
    font-size: 18px;
    font-weight: 100;
}

.em-source-pretext {
    fill: #848280;
    font-size: 11px;
    transform: translate(-5px, -5px);
}

.em-source-dataset-link {
    font-size: 11px;
    fill: #0e47cb;
    cursor: pointer !important;
    text-decoration: underline;
    transform: translate(-5px, -5px);
}

.em-source-dataset-link:hover {
    fill: #082b7a;
    cursor: pointer !important;
    text-decoration: underline;
}

.em-frame {
    stroke-width: 0;
    stroke: grey;
}

/* Graticule styling */
.em-graticule {
    stroke: lightgray;
    stroke-width: 1;
}
.em-frame,
.em-graticule {
    fill: none;
    pointer-events: none;
}

.em-sea {
    fill: white;
    /* pointer-events: none; */
}

.em-scalebar-line {
    stroke: #696969;
    stroke-width: 0.8px;
}

.em-scalebar-label {
    font-size: 9px;
    text-anchor: middle;
}

/* Bottom text and symbol styling */
.em-footnote {
    fill: #848280;
    pointer-events: all;
    cursor: pointer !important;
    font-size: 11px;
    transform: translate(5px, -5px);
}

.em-footnote a {
    fill: #0e47cb;
    text-decoration: underline;
}

.em-footnote a:hover {
    fill: #0a328e;
}

.em-centroid,
.em-coxcomb g {
    cursor: pointer !important;
}

.em-flow-link {
    cursor: pointer !important;
}

.em-flow-link-outline {
    cursor: pointer !important;
}

.em-flow-labels {
    font-size: 15px;
    stroke-width: 1px;
    fill: #696969;
    pointer-events: none;
}

.em-flow-labels-halo {
    font-size: 15px;
    stroke-width: 2px;
    fill: white;
    pointer-events: none;
}

.em-grid-rect,
.em-grid-hexagon {
    stroke: white;
}

.em-flow-donuts {
    cursor: pointer !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/map.css"],"names":[],"mappings":"AASA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA,aAAa;AACb;;;;;IAKI,yCAAyC;AAC7C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,mBAAmB;AACnB;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,uBAAuB;AAC3B;;AAEA,+BAA+B;AAC/B;;IAEI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;;IAEI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["@import './map-types/proportional-symbol.css';\r\n@import './map-types/coxcomb.css';\r\n@import './map-types/alpha.css';\r\n@import './map-types/flow.css';\r\n@import './map-types/pie.css';\r\n@import './map-types/sparkline.css';\r\n@import './map-types/waffle.css';\r\n@import './map-types/bar.css';\r\n\r\n/* wrapper DOM */\r\n.em-map-wrapper {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.em-map-wrapper > svg {\r\n    display: block;\r\n}\r\n\r\n/* General text settings */\r\ntext {\r\n    pointer-events: none;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\na text {\r\n    pointer-events: all;\r\n}\r\n\r\n/* Main map */\r\n.em-map text,\r\n.em-legend text,\r\n.em-title,\r\n.em-subtitle,\r\n.em-footnote {\r\n    font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\n.em-map.em-draggable g {\r\n    cursor: grab;\r\n}\r\n\r\n.em-map.em-dragging g {\r\n    cursor: grabbing;\r\n    cursor: -webkit-grabbing;\r\n}\r\n\r\n/* Coastal margin */\r\n.em-coastal-margin {\r\n    filter: url(#em-coastal-blur);\r\n    stroke-linejoin: round;\r\n    stroke-linecap: round;\r\n    fill: none;\r\n    stroke-width: 1;\r\n    stroke: rgb(0, 52, 107);\r\n}\r\n\r\n/* Title and subtitle styling */\r\n.em-title,\r\n.em-inset-title {\r\n    fill: #4c4b4b;\r\n    stroke: none;\r\n}\r\n\r\n.em-title {\r\n    font-size: 21px;\r\n    font-weight: bold;\r\n}\r\n\r\n.em-subtitle,\r\n.em-inset-subtitle {\r\n    fill: #4c4b4b;\r\n    fill-opacity: 0.9;\r\n    stroke: none;\r\n    stroke-linejoin: round;\r\n    paint-order: stroke;\r\n}\r\n\r\n.em-subtitle {\r\n    font-size: 18px;\r\n    font-weight: 100;\r\n}\r\n\r\n.em-source-pretext {\r\n    fill: #848280;\r\n    font-size: 11px;\r\n    transform: translate(-5px, -5px);\r\n}\r\n\r\n.em-source-dataset-link {\r\n    font-size: 11px;\r\n    fill: #0e47cb;\r\n    cursor: pointer !important;\r\n    text-decoration: underline;\r\n    transform: translate(-5px, -5px);\r\n}\r\n\r\n.em-source-dataset-link:hover {\r\n    fill: #082b7a;\r\n    cursor: pointer !important;\r\n    text-decoration: underline;\r\n}\r\n\r\n.em-frame {\r\n    stroke-width: 0;\r\n    stroke: grey;\r\n}\r\n\r\n/* Graticule styling */\r\n.em-graticule {\r\n    stroke: lightgray;\r\n    stroke-width: 1;\r\n}\r\n.em-frame,\r\n.em-graticule {\r\n    fill: none;\r\n    pointer-events: none;\r\n}\r\n\r\n.em-sea {\r\n    fill: white;\r\n    /* pointer-events: none; */\r\n}\r\n\r\n.em-scalebar-line {\r\n    stroke: #696969;\r\n    stroke-width: 0.8px;\r\n}\r\n\r\n.em-scalebar-label {\r\n    font-size: 9px;\r\n    text-anchor: middle;\r\n}\r\n\r\n/* Bottom text and symbol styling */\r\n.em-footnote {\r\n    fill: #848280;\r\n    pointer-events: all;\r\n    cursor: pointer !important;\r\n    font-size: 11px;\r\n    transform: translate(5px, -5px);\r\n}\r\n\r\n.em-footnote a {\r\n    fill: #0e47cb;\r\n    text-decoration: underline;\r\n}\r\n\r\n.em-footnote a:hover {\r\n    fill: #0a328e;\r\n}\r\n\r\n.em-centroid,\r\n.em-coxcomb g {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.em-flow-link {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.em-flow-link-outline {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.em-flow-labels {\r\n    font-size: 15px;\r\n    stroke-width: 1px;\r\n    fill: #696969;\r\n    pointer-events: none;\r\n}\r\n\r\n.em-flow-labels-halo {\r\n    font-size: 15px;\r\n    stroke-width: 2px;\r\n    fill: white;\r\n    pointer-events: none;\r\n}\r\n\r\n.em-grid-rect,\r\n.em-grid-hexagon {\r\n    stroke: white;\r\n}\r\n\r\n.em-flow-donuts {\r\n    cursor: pointer !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
